import React from "react";
import { IconGlobal } from "../../../../icons";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const layoutRuleItems = [
  {
    label: "Container-Inhalt",
    value: "20px",
    description: "Abstand von Container-Rändern zum Inhalt.",
  },
  {
    label: "Sections mit Trennlinie",
    value: "20px",
    description: "Abstand zwischen Sections, wenn sie durch eine Linie getrennt sind.",
  },
  {
    label: "Innerhalb Section",
    value: "16px",
    description: "Abstand zwischen Section-Header und Section-Inhalt.",
  },
];

const layoutMeasurements = [
  { label: "Page Padding", value: "24px" },
  { label: "Header -> Content", value: "24px" },
  { label: "Content Columns", value: "24px" },
  { label: "Content Stack", value: "16px" },
];

function LayoutRuleBox() {
  return (
    <div className="ds-docs-layout-rule-box">
      <div className="ds-docs-layout-rule-box__label">Anwendungsregel</div>
      <div className="ds-docs-layout-rule-box__list">
        {layoutRuleItems.map((item) => (
          <div key={item.label} className="ds-docs-layout-rule-box__item">
            <span>{item.label}</span>
            <strong>{item.value}</strong>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

function LayoutMeasurementList() {
  return (
    <div className="ds-docs-layout-measurements" aria-label="Default Layout 1 Abstände">
      {layoutMeasurements.map((item) => (
        <div key={item.label} className="ds-docs-layout-measurement">
          <span>{item.label}</span>
          <strong>{item.value}</strong>
        </div>
      ))}
    </div>
  );
}

function DefaultLayoutPreview() {
  return (
    <div className="ds-docs-default-layout-preview" aria-label="Default Layout 1 Vorschau">
      <div className="ds-docs-default-layout-preview__sidebar">Sidebar</div>
      <div className="ds-docs-default-layout-preview__page">
        <div className="ds-docs-default-layout-preview__topbar">Topbar</div>
        <div className="ds-docs-default-layout-preview__workspace">
          <div className="ds-docs-default-layout-preview__workspace-label">24px Page Padding</div>
          <div className="ds-docs-default-layout-preview__header">Page Header</div>
          <div className="ds-docs-default-layout-preview__gap-label">24px</div>
          <div className="ds-docs-default-layout-preview__content">
            <div className="ds-docs-default-layout-preview__column">
              <div className="ds-docs-default-layout-preview__block">Toolbar</div>
              <div className="ds-docs-default-layout-preview__stack-label">16px</div>
              <div className="ds-docs-default-layout-preview__block ds-docs-default-layout-preview__block--large">
                Table
              </div>
            </div>
            <div className="ds-docs-default-layout-preview__inline-gap">24px</div>
            <div className="ds-docs-default-layout-preview__column ds-docs-default-layout-preview__column--detail">
              <div className="ds-docs-default-layout-preview__block ds-docs-default-layout-preview__block--large">
                Detail
              </div>
              <div className="ds-docs-default-layout-preview__stack-label">16px</div>
              <div className="ds-docs-default-layout-preview__block">Card</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function LayoutsDocs() {
  return (
    <DocsSectionCard title="Layout">
      <div className="ds-docs-layout-section">
        <div className="ds-docs-spotlight-grid ds-docs-spotlight-grid--layout">
          <DocsPreviewPanel label="Default Layout 1" icon={IconGlobal}>
            <div className="ds-docs-preview-surface ds-docs-layout-sheet">
              <DefaultLayoutPreview />
              <LayoutMeasurementList />
            </div>
          </DocsPreviewPanel>

          <div className="ds-docs-layout-side">
            <DocsNiceToKnow
              intro="Default Layout 1 ist das Standardlayout für normale V2-Pages."
              items={[
                "Für normale V2-Pages AppDefaultLayout1 verwenden.",
                "Page Padding und Header-Abstand sind damit gesetzt.",
                "Content danach gemäss allgemeinen Regeln aufbauen, so wie im Bild gezeigt.",
              ]}
            />
            <LayoutRuleBox />
          </div>
        </div>
      </div>
    </DocsSectionCard>
  );
}
